<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row mx-0">
            <div class="col-md-12 col-12">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3>Employee Settings</h3>
              </div>
              <div class="col-md-12">
                <div class="my-5 vtabs1">
                  <div class="row">
                    <div class="col-md-3 col-sm-12 px-0">
                      <div class="d-flex align-items-start">
                        <div
                          class="nav flex-column nav-pills w-100"
                          id="v-pills-tab"
                          role="tablist"
                          aria-orientation="vertical"
                        >
                          <!--<li class="nav-link" id="v-pills-one-tab"
                                                        data-bs-toggle="pill" data-bs-target="#v-pills-one"
                                                        type="button" role="tab" aria-controls="v-pills-one"
                                                        aria-selected="false">Personal Information</li>-->
                          <li
                            class="nav-link active"
                            id="v-pills-three-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-three"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-three"
                            aria-selected="true"
                          >
                            Communication Preference
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9 col-12 main-tbscontdv pdng-addclntpg">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade" id="v-pills-one" role="tabpanel" aria-labelledby="v-pills-one-tab">
                          <form [formGroup]="employeeSettingsForm">
                            <div class="row clentpg-settingin">
                              <div class="col-12">
                                <div class="mb-2 col-md-4 col-12 pe-3">
                                  <label for="employeeCode" class="form-label">Username</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="employeeCode"
                                    id="employeeCode"
                                  />
                                </div>
                                <div class="col-12 mt-0 d-flex mb-3">
                                  <button
                                    type="button"
                                    disabled
                                    class="upload-btnactyvtyside"
                                    (click)="openChangePassword()"
                                  >
                                    CHANGE PASSWORD
                                  </button>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="firstName" class="form-label">First Name</label>
                                  <input type="text" class="form-control" formControlName="firstName" id="firstName" />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="middleName" class="form-label">Middle Name</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="middleName"
                                    id="middleName"
                                  />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="lastName" class="form-label">Last Name</label>
                                  <input type="text" class="form-control" formControlName="lastName" id="lastName" />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="employeeID" class="form-label">Employee ID</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="employeeCode"
                                    id="employeeID"
                                  />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="doj" class="form-label">Date of Joining</label>
                                  <input type="text" class="form-control" formControlName="doj" id="doj" />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="dob" class="form-label">Date of birth</label>
                                  <input type="text" class="form-control" formControlName="dob" id="dob" />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="location" class="form-label">Location</label>
                                  <input type="text" class="form-control" formControlName="location" id="location" />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="primaryEmailId" class="form-label">E-Mail ID - Primary</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="primaryEmailId"
                                    id="primaryEmailId"
                                  />
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3">
                                  <label for="maritalStatus" class="form-label">Marital Status</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="maritalStatus"
                                    id="maritalStatus"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-12 d-flex justify-content-end acvtypglastbtn perinf px20">
                              <button type="button" class="btn" (click)="getSave()">SAVE</button>
                              <button type="button" class="btn">DISCARD</button>
                            </div>
                          </form>
                        </div>

                        <div
                          class="tab-pane fade show active"
                          id="v-pills-three"
                          role="tabpanel"
                          aria-labelledby="v-pills-three-tab"
                        >
                          <form [formGroup]="communicationForm">
                            <div class="row">
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Email</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="antb"
                                      [formControlName]="EMAIL"
                                      [checked]="communicationForm.get(EMAIL)?.value"
                                      (change)="setPreferences(EMAIL)"
                                    />
                                    <label for="antb"></label>
                                    <span>{{ communicationForm.get(EMAIL)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>SMS</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="eitb"
                                      [formControlName]="SMS"
                                      [checked]="communicationForm.get(SMS)?.value"
                                      (change)="setPreferences(SMS)"
                                    />
                                    <label for="eitb"></label>
                                    <span>{{ communicationForm.get(SMS)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div>
                          <!--    <div class="col-md-4 col-12">
                                <div class="mb-3 ceckcus-boxxtgl">
                                  <h3>Whatsapp</h3>
                                  <div class="custm-toglbtn">
                                    <input
                                      type="checkbox"
                                      id="rdtb"
                                      [formControlName]="WHATSAPP"
                                      [checked]="communicationForm.get(WHATSAPP)?.value"
                                      (change)="setPreferences(WHATSAPP)"
                                    />
                                    <label for="rdtb"></label>
                                    <span>{{ communicationForm.get(WHATSAPP)?.value ? ENABLED : DISABLED }}</span>
                                  </div>
                                </div>
                              </div> -->
                              <div class="col-12 text-end justify-content-end clientsetingpglst">
                                <button type="button" class="btn" (click)="saveEmployeeNotificationPreference()">
                                  SAVE
                                </button>
                                <button type="button" class="btn">DISCARD</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div #targetContainer></div>
